module.exports = __webpack_public_path__ + "static/sms-logo-d6a007b3507310184755127da585026a.png";